import { Task, Employee } from "@/types/v2";
import {
  getEmployeeName,
  getEmployeeInitials,
  getServiceAdvisorColor,
} from "@/lib/employees";

export interface TaskPermissions {
  canModify: (task: Task) => boolean;
  modifyDeniedReason: (task: Task) => string | undefined;
}

export interface TaskRowDisplayProps {
  roNumber?: string;
  assigneeName?: string;
  assigneeInitials?: string;
  assigneeColor?: string;
  canModify: boolean;
  disabledReason?: string;
}

/**
 * Maps a Task to the display-only props shared by every TaskRow surface.
 * `roNumber` is caller-supplied: the shop-wide tab resolves it per card; the
 * RO strip passes undefined because every row is the same RO.
 */
export const taskToRowProps = (
  task: Task,
  employees: Employee[],
  permissions: TaskPermissions,
  roNumber?: string
): TaskRowDisplayProps => {
  const resolved = task.assigneeId
    ? employees.some((e) => e.id === task.assigneeId)
    : false;
  return {
    roNumber,
    assigneeName: resolved
      ? getEmployeeName(task.assigneeId, employees) || undefined
      : undefined,
    assigneeInitials: resolved
      ? getEmployeeInitials(task.assigneeId, employees) || undefined
      : undefined,
    assigneeColor: resolved
      ? getServiceAdvisorColor(task.assigneeId, employees)
      : undefined,
    canModify: permissions.canModify(task),
    disabledReason: permissions.modifyDeniedReason(task),
  };
};
